export const SET_MOSTRAR_TUTORIAL = 'SET_MOSTRAR_TUTORIAL';
export const SET_CONFIGURACOES = 'SET_CONFIGURACOES';
export const SET_COLAPSAR_MENU = 'SET_COLAPSAR_MENU';
export const SET_TOKEN_VALIDO = 'SET_TOKEN_VALIDO';
export const SET_LOADING = 'SET_LOADING';
export const SET_TOKEN = 'SET_TOKEN';
